export default __webpack_public_path__ + "static/media/ayush.e645fd5d.svg";